module.exports = __webpack_public_path__ + "img/logo_bjd.4a556535.png";